import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PageContentLayoutTemplate from "./PageContentLayoutTemplate";
const PageContentLayout = ({
  children,
  pageName,
  addcallbackFunction,
  tooltip,
}) => {
  const theme = useTheme();
  return (
    <Box sx={theme.layout.mainContainer}>
      <PageContentLayoutTemplate
        children={children}
        pageName={pageName}
        addcallbackFunction={addcallbackFunction}
        tooltip={tooltip}
      ></PageContentLayoutTemplate>
    </Box>
  );
};

export default PageContentLayout;
